export default "__VITE_ASSET__BWhh2JKA__"